import { normalize } from './helpers.js';

export function parseLocationSearchState(params) {
    const where = params.get('where') || '';
    const lat = params.get('lat');
    const lng = params.get('lng');

    // The backend still supports text-based scopes for old/bookmarked URLs.
    // Treat those as selected without allowing newly typed free text through.
    let whereData = where
        ? {
              lat: null,
              lng: null,
              ...(params.get('placeType') === 'listing'
                  ? { placeType: 'listing' }
                  : {})
          }
        : null;

    if (lat && lng) {
        whereData = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
            placeType: params.get('placeType') || undefined
        };
    }

    return { where, whereData };
}

export function resolveComposerDestination(
    { where, whereData, composerDestinationSlug },
    locations
) {
    // Selected URL/recent-search values may lack CMS identity. Free text and
    // explicit geocoding selections must remain autocomplete results.
    if (!whereData || !normalize(where)) return null;
    const type = whereData.type || whereData.placeType;
    if (type && type !== 'destination' && type !== 'market') return null;

    const matches = locations.filter(
        (entry) =>
            (!type || entry.type === type) &&
            (whereData.slug
                ? entry.slug === whereData.slug
                : normalize(entry.title) === normalize(where))
    );
    if (matches.length !== 1) return null;

    const selected = matches[0];
    if (selected.type === 'destination') return selected;

    // Keep the parent's tiles open after choosing one of its markets, without
    // changing a directly selected market into a destination search.
    if (
        selected.type === 'market' &&
        selected.parentSlug === composerDestinationSlug
    ) {
        return (
            locations.find(
                (entry) =>
                    entry.type === 'destination' &&
                    entry.slug === composerDestinationSlug
            ) || null
        );
    }
    return null;
}
